const fonts = {
  heading: '"Spline Sans Variable", -apple-system, system-ui, sans-serif',
  body: '"Open Sans Variable", -apple-system, system-ui, sans-serif'
};

export { fonts as default };
